import { Injectable } from '@angular/core';
declare var $:any;


@Injectable()
export class ModalService {
    
    

    constructor( ) { }

    public launchModal() {
        $('#overlay-modal').modal();
        $('#overlay-modal').css("display", "flex");
                
        let that = this;
        // destroy evenmt handlers associated with modal
        $('#overlay-modal').on('hidden.bs.modal', function (e) {
            that.destroyModal();
        });
    }

    public allowDrop(event) {
        event.preventDefault();
    }
    
    public drag(event) {
        var style = window.getComputedStyle(event.target, null);
        event.dataTransfer.setData("text/plain",
        (parseInt(style.getPropertyValue("left"),10) - event.clientX) + ',' + (parseInt(style.getPropertyValue("top"),10) - event.clientY));
    }
    
    public drop(event) {
        var offset = event.dataTransfer.getData("text/plain").split(',');
        var modalDialog = document.getElementById('modal-dialog');
        modalDialog.style.left = (event.clientX + parseInt(offset[0],10)) + 'px';
        modalDialog.style.top = (event.clientY + parseInt(offset[1],10)) + 'px';
        event.preventDefault();
        return false;
    }

    public destroyModal() {
        $('#overlay-modal').off();
        $("#overlay-modal").removeAttr("style");
        $('#modal-dialog').off();
        $("#modal-dialog").removeAttr("style");
        
    }
    
}
   